export const burgerMenu = { title: 'Account' } as const
